export const getDistanceKmString = (distance: number | undefined): string => {
  if (!distance) {
    return "";
  }

  return `${distance} km`;
};

// TransitsTable.tsxに残ってるTransit型への対応でgetDistanceLocalStringを使っているためまだ消せない
export const meterToKilometer = (
  distance: number | undefined
): number | undefined => {
  if (!distance) {
    return undefined;
  }

  return Math.round(distance / 100) / 10;
};

export const getDistanceKmBracketsString = (
  distance: number | undefined
): string => {
  const value = getDistanceKmString(distance);
  if (!value) {
    return "";
  }
  return `(${value})`;
};

export const getDistanceLocalString = (
  distance: number | undefined
): string => {
  if (!distance) {
    return "";
  }

  const distanceInKilometer = meterToKilometer(distance);
  if (distanceInKilometer === 0) {
    return `${distance} m`;
  }
  return `${distanceInKilometer} km`;
};

export const kilometerToMeter = (
  distance: number | undefined
): number | undefined => {
  if (!distance) {
    return undefined;
  }

  return Math.round(distance * 1000);
};
